import styled from "styled-components"
import { ThemeType } from "../../themes/theme"

interface IDividerProps {
  bgColor: keyof ThemeType["colors"]
}
const StyledDividerWrapper = styled.div<IDividerProps>`
  background-color: ${(props) => props.bgColor};
  display: flex;
  justify-content: center;
`

const StyledDivider = styled.hr`
  background-color: ${(props) => props.theme.colors.border};
  border: none;
  height: 1px;
  width: calc(100% - clamp(1.5rem, 1.2rem + 1.5vw, 3rem) * 2);
  margin: 0;
`

const EstimatesDivider = (props: IDividerProps) => {
  const { bgColor } = props
  return (
    <StyledDividerWrapper bgColor={bgColor}>
      <StyledDivider />
    </StyledDividerWrapper>
  )
}

export { EstimatesDivider }
